import { getUrlParameter } from "./getUrlParameter";

describe("getUrlParameter", () => {
    it("returns the search parameter", () => {
        //@ts-ignore
        global.window = Object.create(window);
        const href = "https://trumpf.com/de_DE";
        const search = "&q=hello%20world";
        Object.defineProperty(window, "location", {
            value: { href, search }
        });
        expect(getUrlParameter("q")).toBe("hello world");
    });
});
